import IconDeviceLaptop from '@/shared/uikit/assets/icons/IconDeviceLaptop.svg?react';
import IconBuilding from '@/shared/uikit/assets/icons/IconBuilding.svg?react';
import IconCone from '@/shared/uikit/assets/icons/IconCone.svg?react';
import IconLock from '@/shared/uikit/assets/icons/IconLock.svg?react';
import IconCar from '@/shared/uikit/assets/icons/IconCar.svg?react';
import IconMeetingRoom from '@/shared/uikit/assets/icons/IconMeetingRoom.svg?react';

type UseIconProps = {
	type: string;
	size?: number;
	color?: string;
	classNames?: string;
};

export const useIcon = ({ type, size = 18, color = '#B2B7C2', classNames }: UseIconProps) => {
	switch (type) {
		case 'work_place':
			return <IconDeviceLaptop color={color} fontSize={size} className={classNames} />;

		case 'parking_place':
			return <IconCone color={color} fontSize={size} className={classNames} />;

		case 'meeting_room':
			return <IconMeetingRoom color={color} fontSize={size} className={classNames} />;

		case 'location':
			return <IconBuilding color={color} fontSize={size} className={classNames} />;

		case 'car':
			return <IconCar color={color} fontSize={size} className={classNames} />;

		case 'lock':
			return <IconLock color={color} fontSize={size} className={classNames} />;
	}
};
